export const teamselfFilters = [
  {
    key: 'Self',
    label: 'Self',
  },
  {
    key: 'Team',
    label: 'Team',
  },
];
